import {
  Button,
  Grid,
  IconButton,
  makeStyles,
  Paper,
  Tooltip,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import { DocGenerator } from "utils";
import DownloadSvg from "images/download-02.svg";
import { format } from "date-fns";
import fileDownload from "js-file-download";
import { getMuthootMailTrail } from "./service";

const useStyles = makeStyles((theme) => ({
  value: {
    fontSize: "14px",
    lineHeight: "17px",
    textTransform: "capitalize",
    "&:hover": {
      background: "#E0E0E0",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.9rem",
      lineHeight: "1.2rem",
    },
  },
  valuePaper: {
    padding: "1.5rem",
    cursor: "pointer",
    boxShadow: "none",
    width: "100%",
    border: "1px solid #E0E0E0",
    "&:hover": {
      background: "#E0E0E0",
      '& $downloadButton': {
        visibility: 'visible',
      }
    },
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  menuwidth: {
    width: "200px",
    [theme.breakpoints.down("sm")]: {
      width: "150px",
    },
    [theme.breakpoints.down("xs")]: {
      width: "130px",
    },
  },
  alginCenter: {
    textAlign: "center",
  },
  downloadButton: {
    padding: '6px',
    visibility: 'hidden',
  },
  rowActions: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
  },
  historyButton: {
    textTransform: 'none',
    fontSize: '12px',
    lineHeight: '14px',
    padding: '3px 8px',
    minWidth: 'auto',
    whiteSpace: 'nowrap',
    border: '1px solid #AAAFB9',
    background: '#fff',
  },
}));

const DisputeRowMuthoot = ({
  id,
  name,
  filingDate,
  registrationDate,
  history,
  complaint_category,
  stage,
  status,
  action_due,
  complaint_details,
  closedDate,
  currentTab,
}) => {
  const classes = useStyles();
  const [mailTrailLoading, setMailTrailLoading] = useState(false);

  const download = (event) => {
    event.stopPropagation();
    const params = {
      primary_details: true
    }
    DocGenerator(id, "claimant", "", params);
  };

  const downloadMailTrail = (event) => {
    event.stopPropagation();
    setMailTrailLoading(true);
    getMuthootMailTrail(id)
      .then((response) => {
        fileDownload(response.data, `mail_trail_${id}.pdf`);
      })
      .catch((error) => {
        console.log(error);
        alert("Error downloading mail trail. Please try again.");
      })
      .finally(() => {
        setMailTrailLoading(false);
      });
  };

  const onRowClick = () => {
    history.push(`/disputes/${id}`);
  };

  return (
    <>
      <Paper className={classes.valuePaper} square onClick={onRowClick}>
        <Grid container spacing={2}>
          <Grid item xs sm={1}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Typography className={classes.value}>
                {id ? id : "----"}
              </Typography>
            </div>
          </Grid>
          <Grid item xs sm={2}>
            <Typography className={classes.value}>
              {name.split("&")[0]}
            </Typography>
          </Grid>
          <Grid item xs sm={3}>
            <Typography className={`${classes.value} lineClamp`}>
              {complaint_details ? complaint_details : '---'}
            </Typography>
          </Grid>
          <Grid item xs sm={1}>
            <Typography className={classes.value} style={{ textAlign: 'center' }}>
              {stage}
            </Typography>
          </Grid>
          <Grid item xs sm={1}>
            <Typography className={classes.value} style={{ textAlign: 'center' }}>
              {status}
            </Typography>
          </Grid>
          <Grid item xs sm={1}>
            <Typography className={classes.value} style={{ textAlign: 'center' }}>
              {complaint_category}
            </Typography>
          </Grid>
          <Grid item xs sm={1}>
            <Typography className={classes.value} style={{ textAlign: 'center' }}>
              {action_due}
            </Typography>
          </Grid>
          <Grid item xs sm={2}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography className={classes.value} style={{ textAlign: 'center' }}>
                {currentTab === 'closed' ? (
                  closedDate && <span>{format(new Date(closedDate), "dd/MM/y")}</span>
                ) : (
                  filingDate && <span>{format(new Date(filingDate), "dd/MM/y, h:mm a")}</span>
                )}
              </Typography>
              <div className={classes.rowActions}>
                <Tooltip title='Download Complaint'>
                  <IconButton className={classes.downloadButton} onClick={download} >
                    <img src={DownloadSvg} width='20px' alt="" />
                  </IconButton>
                </Tooltip>
                <Tooltip title='Download Mail Trail'>
                  <span style={{ display: 'inline-flex' }}>
                    <Button
                      size="small"
                      className={classes.historyButton}
                      onClick={downloadMailTrail}
                      disabled={mailTrailLoading}
                    >
                      History
                    </Button>
                  </span>
                </Tooltip>
              </div>
            </div>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

export default DisputeRowMuthoot;
